import { render, staticRenderFns } from "./NtkoGeneratorClerk.vue?vue&type=template&id=6f390a92&scoped=true&"
import script from "./NtkoGeneratorClerk.vue?vue&type=script&lang=js&"
export * from "./NtkoGeneratorClerk.vue?vue&type=script&lang=js&"
import style0 from "./NtkoGeneratorClerk.vue?vue&type=style&index=0&id=6f390a92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f390a92",
  null
  
)

export default component.exports